import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector, deleteCustomSubscriptionRequest } from "Bands/state";
import { BAND_ACTIONS, IBandCustomSubscriptionRequest } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { DeleteModal } from "shared/components";
import { copy } from "shared/assets";

const customCopy = copy.subscription.custom;

interface Props {
  request: IBandCustomSubscriptionRequest;
  handleClose: () => void;
}

export const CancelRequestModal: FC<Props> = ({ request, handleClose }) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(
    dataMetaSelector(BAND_ACTIONS.deleteCustomSubscriptionRequest)
  );
  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteCustomSubscriptionRequest);

  const handleDelete = () => {
    dispatch(deleteCustomSubscriptionRequest(request.id));
  };
  return (
    <DeleteModal
      name=""
      type="custom subscription request"
      handleClose={handleClose}
      handleDelete={handleDelete}
      apiMeta={apiMeta}
      customDeleteCopy={customCopy.messages.confirmCancel
        .replace("%band", request.bands[0].title!)
        .toString()}
      customButtonCopy={customCopy.buttons.confirmCancel}
      customCancelCopy={customCopy.buttons.cancel}
    />
  );
};
